<script lang="ts" setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
const pcBannerVideoID = ref('nxWaj1o_3fs')

const initAni = () => {
  const gTimeLine = gsap.timeline()
  gTimeLine.to('.banner', {
    scrollTrigger: {
      trigger: '.video-box',
      start: 'bottom bottom',
      end: '+=100%',
      pin: true,
      pinSpacing: false,
      markers: false
    }
  })
}
defineExpose({
  initAni
});
// onMounted(() => {
//   nextTick(() => {
//     initAni()
//   })
//   // useImagesLoaded('.banner iframe').then(initAni)
// })
</script>

<template>
  <section class="banner">
    <div class="video-box">
      <div class="video-background">
        <iframe width="100%" height="100%"
          :src="`https://www.youtube.com/embed/${pcBannerVideoID}?playlist=${pcBannerVideoID}&autoplay=1&controls=0&disablekb=1&loop=1&modestbranding=1&playsinline=1&color=white&mute=1&rel=0`"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; loop"
          allowfullscreen></iframe>
      </div>
    </div>
    <div class="banner__itemBox first">
      <Nimg src="./images/story_logo.svg" class="banner__logo" format="" />
      <div class="banner__textFirst">
        與你一起<br />
        打造理想生活
      </div>
    </div>
    <div class="banner__itemBox second">
      <div class="banner__textSecond">
        <div class="banner__textSecond__top">
          從選品、行銷、銷售、通路、物流、客服到府服務，恆隆行以高規格態度對待消費者與代理品牌
        </div>

        <div class="banner__textSecond__bottom">
          恆隆行秉持著為「消費者生活帶來改變」的初衷，精選各國創新品牌，從各領域挖掘品牌，持續創造風潮。
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  &__itemBox {
    position: relative;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    font-size: 20px;
    color: $color-white-1;

    &.first {
      margin-top: -100vh;
    }
  }

  &__itemBox {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__logo {
    width: 100%;
    max-width: 360px;
    margin-bottom: toRem(20);

    img {
      display: block;
      width: 100%;
    }
  }

  &__textFirst {
    font-size: toRem(40);
    font-weight: 500;
    line-height: 1.3;
    text-align: center;
  }

  &__textSecond {
    width: 100%;
    max-width: toRem(445);

    &__top {
      font-size: toRem(20);
      font-weight: 500;
      line-height: 1.4;
      margin-bottom: toRem(24);
    }

    &__bottom {
      font-size: toRem(16);
      font-weight: 400;
      line-height: 1.45;
    }
  }
}

.video-box {
  position: relative;
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -154px;
  background-color: #000;
  pointer-events: none;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.6;
  }
}

* {
  box-sizing: border-box;
}

.video-background {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}

.video-background iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  transform: translate(-50%, -50%);
}

@media (min-aspect-ratio: 16/9) {
  .video-background iframe {
    /* height = 100 * (9 / 16) = 56.25 */
    height: 56.25vw;
  }
}

@media (max-aspect-ratio: 16/9) {
  .video-background iframe {
    /* width = 100 / (9 / 16) = 177.777777 */
    // width: 177.78vh;
    // 遮標題
    width: 300.78vh;
  }
}
</style>
